import { Link } from 'react-router-dom';
import { React, useEffect, useState } from 'react';
import { retrieveToken } from '../../../hooks/use-token';
import { handleMyPlans } from '../../../api/pagamento';
import { handleRedacao, listRedacoes } from '../../../api/redacao';

const MinhasRedacoesTable = () => {
  
  const [allPayments, setAllPayments] = useState([]);
  const [flagApi, setFlagApi] = useState(false);
  const [minhasRedacoes, setMinhasRedacoes] = useState(null);
  
  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    listRedacoes(tokenApi).then(function(result) {
      setMinhasRedacoes(result);
    });
    
  }, []);
  
  return (
    <div className="table-content table-responsive" style={{marginTop: 35}}>
    <table className="table">
    <thead>
    <tr>
    <th className="product-thumbnail">Plano</th>
    <th className="cart-product-name">Sua redação/Tema</th>
    <th className="cart-product-name">Você enviou em</th>
    <th className="cart-product-name">Correção da Prof.ª Pricilla Záttera</th>
    <th className="cart-product-name">Comentário</th>
    <th className="cart-product-name">Nota</th>
    </tr>
    </thead>
    <tbody>
    {Array.isArray(minhasRedacoes) && minhasRedacoes.length > 0 && minhasRedacoes != null && minhasRedacoes.map((redacao, index) => (
      <tr key={index}>
        <td>{redacao.titulo}</td>
        <td><a className="link" href={`https://api.profaprizattera.com.br/storage/uploads/${redacao.file}`} target="_blank">Visualizar - {redacao.tema}</a></td>
        <td>{redacao.enviado_em}</td>
        <td>{(redacao.file_retorno != null) ? <a className="link" href={`https://v1.profaprizattera.com.br/uploads/aluno-redacao/${redacao.file_retorno}`} target="_blank">Ver correção</a> : "-"}</td>
        <td>{redacao.comentario}</td>
        <td>{redacao.nota}</td>
      </tr>
      ))}
      </tbody>
      </table>
      </div>
      );
      
    };
    
    export default MinhasRedacoesTable;